import { Customer } from "../../models/Customer";
import { Person } from "../../models/Person";
import { CustomerMeeting } from "../store/CustomerMeeting";
import { CustomerMeetingDto } from "./api/CustomerMeetingDto";

export class CustomerMeetingFromResponse {
    constructor(private customerMeetingFromResponse: CustomerMeetingDto) {}

    customerMeeting(): CustomerMeeting {
        return {
            meetingId: this.customerMeetingFromResponse.meetingId,
            organizerId: this.customerMeetingFromResponse.organizerId,
            subject: this.customerMeetingFromResponse.subject,
            customers: this.customerMeetingFromResponse.customers.map((customer) =>
                Customer.Existing(customer.name, customer.email, customer.id)
            ),
            externalConsultants: this.customerMeetingFromResponse.externalConsultants?.map((i) =>
                Person.Existing(i.name, i.email)
            ),
            thirdParties: this.customerMeetingFromResponse.thirdParties?.map((i) => Person.Existing(i.name, i.email)),
            companyName: this.customerMeetingFromResponse.companyName,
            joinUrl: this.customerMeetingFromResponse.joinUrl,
            urlHash: this.customerMeetingFromResponse.urlHash,
            startAt: new Date(this.customerMeetingFromResponse.startAt),
            endAt: new Date(this.customerMeetingFromResponse.endAt),
            additionalAttendeesEmails: this.customerMeetingFromResponse.additionalAttendeesEmails,
            status: this.customerMeetingFromResponse.status,
            businessLine: this.customerMeetingFromResponse.businessLine,
            regon: this.customerMeetingFromResponse.regon,
            c6: this.customerMeetingFromResponse.c6,
            isCancelled: this.customerMeetingFromResponse.isCancelled,
            languageVersion: this.customerMeetingFromResponse.languageVersion,
            isEnded: this.customerMeetingFromResponse.isEnded,
            meetingKind: this.customerMeetingFromResponse.meetingKind,
        };
    }
}
